module.exports = __webpack_public_path__ + "static/img/logo7.8dcb709.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo7.png
// module id = qzBV
// module chunks = 1